import { Component, OnInit, Input } from '@angular/core';
import '../../../../assets/card.js';
import { UserService, MessagesServices, ScrollService } from '../../../api/';
import { PaypalErrorsComponent } from '../../../paypal-errors.component';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmDialogComponent } from '../../../';
import { MdDialog, MdDialogRef } from '@angular/material';
import * as _ from 'lodash';
// import { BlockUI, NgBlockUI } from 'ng-block-ui';
@Component({
    selector: 'app-payment-info',
    templateUrl: './payment-info.component.html',
    styleUrls: ['./payment-info.component.css']
})
export class PaymentInfoComponent implements OnInit {
    private selectedPackage: any = null;
    private model: PaymentInfoForm = new PaymentInfoForm();
    private packages: Array<any> = [];
    private profileData: any = {};
    private amount: number = 0;
    private defaultFormat = /(\d{1,4})/g;
    private errorArray = [];
    private loading: boolean = false;
    public countries: Array<any> = new Array<any>();
    dialogRef: MdDialogRef<PaypalErrorsComponent>;
    confirmDialogRef: MdDialogRef<ConfirmDialogComponent>;
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';
    msg3: any = '';
    title3: any = '';
    checkIfMobile: boolean = false;
    public checkForDisplayingSkipBtn: boolean = false;
    // @BlockUI() blockUI: NgBlockUI;
    private cards = [{
        type: 'amex',
        pattern: /^3[47]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        length: [15],
        cvcLength: [4],
        luhn: true
    }, {
        type: 'dankort',
        pattern: /^5019/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'dinersclub',
        pattern: /^(36|38|30[0-5])/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
        length: [14],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'discover',
        pattern: /^(6011|65|64[4-9]|622)/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'jcb',
        pattern: /^35/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'laser',
        pattern: /^(6706|6771|6709)/,
        format: this.defaultFormat,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'maestro',
        pattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
        format: this.defaultFormat,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'mastercard',
        pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'unionpay',
        pattern: /^62/,
        format: this.defaultFormat,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: false
    }, {
        type: 'visaelectron',
        pattern: /^4(026|17500|405|508|844|91[37])/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'elo',
        pattern: /^(4011|438935|45(1416|76|7393)|50(4175|6699|67|90[4-7])|63(6297|6368))/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'visa',
        pattern: /^4/,
        format: this.defaultFormat,
        length: [13, 16, 19],
        cvcLength: [3],
        luhn: true
    }];

    private updateinfo: boolean = false;
    public onlineOffline: boolean = navigator.onLine;

    constructor(private scrollService:ScrollService,private userService: UserService, private sm: MessagesServices, private route: ActivatedRoute, private toastyService: ToastyService, private router: Router, public dialog: MdDialog) {
        //getting messages from db
        // this.blockUI.start('Loading Please waite...');
        // setTimeout(() => {
        //     this.blockUI.stop(); // Stop blocking
        // }, 3000);
        window.addEventListener('online', () => {this.onlineOffline = true;});
        window.addEventListener('offline', () => {this.onlineOffline = false;});

        this.messages = this.sm.messags;
        this.setMessages();
        this.checkForDisplayingSkipBtn = false;

        if (this.route.snapshot.data['update'] === true) {
            this.updateinfo = true;
        }
        this.route
            .queryParams
            .subscribe(params => {
                this.checkForDisplayingSkipBtn = params['check'];
            });
    }

    /**
     * setting system messages
     **/

    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_TRANSACTION_PROCESSED_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_ERROR_IN_COMPLETING_REQUEST') {
                    this.title2 = this.messages[i].title;
                    this.msg2 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_CANNOT_ENTERTAINED_BY_SERVER') {
                    this.title3 = this.messages[i].title;
                    this.msg3 = this.messages[i].message;
                }
            }
            // alert(this.msg1);
            // alert(this.msg2);
            // alert(this.msg3);
            // alert(this.msg4);
        }
    }

    ngOnInit() {

        new Card({
            form: document.querySelector('.form'),
            container: '.card-wrapper',
            // Strings for translation - optional
            messages: {
                validDate: 'valid\ndate', // optional - default 'valid\nthru'
                monthYear: 'mm/yyyy', // optional - default 'month/year'
            },

            // Default placeholders for rendered fields - optional
            placeholders: {
                number: '•••• •••• •••• ••••',
                name: 'Full Name',
                expiry: '••/••••',
                cvc: '•••'
            },

            // masks: {
            //   cardNumber: '•' // optional - mask card number
            // },

            // if true, will log helpful messages for setting up Card
            debug: true
        });
        if(this.onlineOffline) {
            this.userService.getPackages().subscribe((res) => {
                if (res && res.length > 0) {
                    res.forEach((arrayItem) => {
                        this.packages.push(arrayItem);
                        this.selectedPackage = arrayItem;
                    });
                }
            });
            this.userService.getCountries().subscribe((res) => {
                this.countries = res;
            });
            this.userService.getUserProfileData('basic').subscribe((res) => {
                this.profileData = res.profile;
                this.model.fullName = res.profile.fullname;
                localStorage.setItem('status', res.profile.status);
            });
        }
        if (screen.width < 641) {
            this.checkIfMobile = true;
        }
        this.scrollService.enableScrollIfDisabled();
    }

    routToDashBoard() {
        this.router.navigate(['./']);
    }

    submitBilling(event) {
        event.stopPropagation();
        event.preventDefault();
        this.errorArray = [];
        if(this.updateinfo) {
            this.updateBilling();
        } else {
            if (!this.selectedPackage || !this.selectedPackage.id) {
                this.errorArray['package'] = 'Please Select A Package First.';
                return false;
            }
            this.processBilling();
        }

    }

    notifyDialog(data) {
        let msg = (data.msg) ? data.msg : '';
        this.confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
            disableClose: false,
        });
        this.confirmDialogRef.componentInstance.message = msg;
        this.confirmDialogRef.componentInstance.infoMode = data.same;
        if (data.same) {
            this.selectedPackage = {};
        }
        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result && result === true) {
                // this.processBilling();
            } else {
                this.selectedPackage = {};
            }
        });
    }

    setCardNumber( $event) {

        this.model.cardNumber=$event.target.value;

    }
    
    processBilling() {
        this.loading = true;
        let cardType = this.cardFromNumber(this.model.cardNumber);
        this.model.cardType = (cardType) ? cardType.type : '';
        this.model.month = this.model.expiry.split('/')[0];
        this.model.year = this.model.expiry.split('/')[1];
        let obj: any = {
            card_number: parseInt(this.model.cardNumber.replace(/ /g, '')),
            cvv: this.model.cvc,
            cardholder_name: this.model.fullName,
            package: this.selectedPackage.id,
            expiry: this.model.expiry,
            expiry_month: this.model.month.trim(),
            expiry_year: this.model.year.trim(),
            card_type: this.model.cardType,
            // billing info also passed here
            address1: this.profileData.address1,
            country: this.profileData.country,
            town_city: this.profileData.town_city,
            state_region: this.profileData.state_region,
            postalcode: this.profileData.postalcode
        };
        if(this.onlineOffline) {
            this.userService.submitPaymentInfo(obj).subscribe((res) => {
                let toastOptions: ToastOptions;
                if (this.title1 && this.msg1) {
                    toastOptions = {
                        title: this.title1,
                        msg: this.msg1,
                        showClose: true,
                        timeout: 2000,
                        theme: 'default'
                    };
                } else if (res.status && res.message) {
                    toastOptions = {
                        title: res.status,
                        msg: res.message,
                        showClose: true,
                        timeout: 2000,
                        theme: 'default'
                    };

                } else {
                    toastOptions = {
                        title: "success",
                        msg: "Your request has been successful.",
                        showClose: true,
                        timeout: 2000,
                        theme: 'default'
                    };
                }
                if (res && res.status === 'success') {
                    // storing the latest package id locally
                    localStorage.setItem("package", this.selectedPackage.id);
                    this.toastyService.success(toastOptions);
                    this.router.navigate(['/discover-new-music']);

                } else {
                    // Paypal api handle errors
                    if (res.status === 'error' && res.data && res.data.length > 0) {
                        this.dialogRef = this.dialog.open(PaypalErrorsComponent, {});
                        this.dialogRef.componentInstance.errors = res.data;
                    } else if (res.status === 'error' && res.message && res.message.length > 0) {
                        toastOptions.title = this.title2;
                        toastOptions.msg = res.message;
                        this.toastyService.error(toastOptions);
                    } else {
                        toastOptions.title = this.title2;
                        toastOptions.msg = this.msg2;
                        this.toastyService.error(toastOptions);
                    }
                }

                this.loading = false;
            }, (err) => {
                console.log(err);
                this.handleErrors(err);
                this.loading = false;
            }, () => {
            });
        }else{
            this.loading = false;
        }
    }

    updateBilling() {
        this.loading = true;
        let cardType = this.cardFromNumber(this.model.cardNumber);
        this.model.cardType = (cardType) ? cardType.type : '';
        this.model.month = this.model.expiry.split('/')[0];
        this.model.year = this.model.expiry.split('/')[1];
        let obj: any = {
            card_number: parseInt(this.model.cardNumber.replace(/ /g, '')),
            cvv: this.model.cvc,
            cardholder_name: this.model.fullName,
            expiry: this.model.expiry,
            expiry_month: this.model.month.trim(),
            expiry_year: this.model.year.trim(),
            card_type: this.model.cardType,
            // billing info also passed here
        };
        if(this.onlineOffline) {
            this.userService.updatePaymentInfo(obj).subscribe((res) => {
                let toastOptions: ToastOptions = {
                    title: this.title1,
                    msg: this.msg1,
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };

                if (res && res.status === 'success') {
                    console.log(res);
                    toastOptions.msg = res.message;
                    this.toastyService.success(toastOptions);
                    this.router.navigate(['/dashboard/my-packages']);

                } else {
                    // Paypal api handle errors
                    if (res.status === 'error' && res.data && res.data.length > 0) {
                        this.dialogRef = this.dialog.open(PaypalErrorsComponent, {});
                        this.dialogRef.componentInstance.errors = res.data;
                    } else if (res.status === 'error' && res.message && res.message.length > 0) {
                        toastOptions.title = this.title2;
                        toastOptions.msg = res.message;
                        this.toastyService.error(toastOptions);
                    } else {
                        toastOptions.title = this.title2;
                        toastOptions.msg = this.msg2;
                        this.toastyService.error(toastOptions);
                    }
                }
                this.loading = false;
            }, (err) => {
                console.log(err);
                this.handleErrors(err);
                this.loading = false;
            }, () => {
            });
        } else {
            this.loading = false;
        }
    }

    cardFromNumber = function (num) {
        var card, j, len;
        num = (num + '').replace(/\D/g, '');
        for (j = 0, len = this.cards.length; j < len; j++) {
            card = this.cards[j];
            if (card.pattern.test(num)) {
                return card;
            }
        }
    };

    chooseThisPlan(selected) {
        this.amount = selected.amount;
        this.selectedPackage = selected;
        if(this.onlineOffline){
        this.userService.getPackageConsentDetails(this.selectedPackage.id).subscribe((res) => {
            this.notifyDialog(res);
        });
        }
        var ele = document.getElementsByClassName("myclass");
        if(ele[0]) {
            ele[0].className = ele[0].className.replace(/\myclass\b/g, "");
            console.log(ele[0]);
        }
        document.getElementById(selected.id).className = "myclass";
        this.backgroundColorOfPackage(selected.title, selected.id);
    }

    backgroundColorOfPackage(title, id) {
        if(this.packages) {
            for(var i = 0; i < this.packages.length; i++) {
                document.getElementById(this.packages[i].id).style.backgroundColor = "#424242";
                if(this.packages[i].title == title && this.packages[i].id == id) {
                    document.getElementById(id).style.backgroundColor = "green";
                }
            }
        }
    }

    handleErrors(err: any) {
        if (err.status === 500) {
            let toastOptions: ToastOptions = {
                title: this.title3,
                msg: this.msg3,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.error(toastOptions);
            return;
        }
        this.errorArray = [];
        let validationErrors = JSON.parse(err._body);
        if (err._body) {
            for (let index = 0; index < validationErrors.length; index++) {
                this.errorArray[validationErrors[index].field] = validationErrors[index].message;
            }
        }
    }

}

class PaymentInfoForm {
    public cardNumber: string = '';
    public fullName: string = '';
    public expiry: string = '';
    public year: string = '';
    public month: string = '';
    public cvc: string = '';
    public cardType: string = '';
}




// WEBPACK FOOTER //
// ./src/app/user/signup/payment-info/payment-info.component.ts